import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emHasFullError',
  standalone: false,
})
export class HasFullErrorPipe implements PipeTransform {
  public transform(value: string | undefined): boolean {
    if (!value) {
      return false;
    }

    return value.includes('§§§');
  }
}
